import dayjs from 'dayjs'
import React, {useEffect, useRef, useState} from 'react'
// import Map from './Map'
import map from '../../assets/images/map.png'
import folderImg from '../../assets/icons/folder.svg'
import 'dayjs/locale/id'

function JurnalDetailCard({
                              type, tanggal, waktu, link_foto, catatan, status, latitude, longitude,
                              is_valid, is_valid_wkt, loading, popUp, setPopUp, popUpMap, setPopUpMap, checkNull
                          }) {

    const wrapperRef = useRef(null);
    const [imgLoaded, setImgLoaded] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setPopUpMap(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [setPopUpMap]);

    useEffect(() => {
        dayjs.locale('id')
    }, [])

    function validasi(tipe){
        if(tipe === "Tidak Valid"){
            return "#FF4530"
        }else if(tipe === "Valid"){
            return "#277FFE"
        }else {
            return "#9B9B9B"
        }
    }

    function isValid() {

        console.log(is_valid)
        return is_valid === 1
    }

    function isNull(state) {
        return state === null || state === undefined
    }

    return (
        <div className='masuk-keluar'>
            <div className='jam-masuk'>
                <h3>{type}</h3>
                <p>
                    {tanggal
                        ? dayjs(tanggal).format('dddd, DD MMMM YYYY') + ', pukul'
                        : '-'
                    }
                    <span className={is_valid_wkt === 1 ? 'valid-text' : 'gak-valid-text'}>
                        {waktu
                            ? ` ${waktu.slice(0, 5)}`
                            : ''
                        }
                    </span>
                </p>
            </div>

            <div className='card' style={{height: '218px', justifyContent: 'space-between'}}>


                <div className='note'>
                    <h3 style={{fontWeight: 500, fontSize: "0.85em"}}>Note Siswa:</h3>

                    <p>{checkNull(catatan)}</p>
                </div>
                <div className='coordinates'>
                    <div className='location'>
                        <h3>Status Jurnal</h3>
                        <p style={{color:validasi(status)}}>{checkNull(status)}</p>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default JurnalDetailCard